import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { MarketingCharacteristics } from '@app/constants';
import { setEicRequired } from '@app/redux/addOns';

import { ProductType } from '@mfe/shared/schema-types';
import { getCharacteristicValue } from '@mfe/shared/utils';

import { YES } from '../types';

export const useSetAddOnConsent = (productTypes: ProductType[] | null) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!productTypes || !productTypes.length) {
      return;
    }

    productTypes
      .flatMap((product) =>
        product.is_grouped_product && product.package_types?.[0]?.product_types
          ? product.package_types[0].product_types
          : []
      )
      .forEach((subProduct) => {
        if (!subProduct) {
          return;
        }
        if (subProduct.id) {
          const eicRequired =
            getCharacteristicValue(
              subProduct.marketing_copy?.translations?.[0]?.characteristics,
              MarketingCharacteristics.EXPLICIT_CONSENT_REQUIRED
            )?.toLowerCase() === YES;
          // Set explicit consent for grouped product sub-types
          // This is necessary to ensure that the consent is set correctly for each sub-product
          // when the grouped product is selected.
          dispatch(setEicRequired({ id: subProduct.id, eicRequired }));
        }
      });
  }, [productTypes, dispatch]);
};
